import { format, parseISO } from 'date-fns';

export const { format: formatPrice } = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatDate = (date: string): string =>
  !date ? '' : format(parseISO(date), 'dd/MM/yyyy');
